export { GenericIntegrationPage } from "./GenericIntegrationPage";
